import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

type ToastType = 'success' | 'error' | 'warning' | 'info';

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    private defaultDuration = 2500;

    constructor(private toastController: ToastController) { }

    async show(
        message: string,
        type: ToastType = 'info',
        duration?: number
    ) {
        const toast = await this.toastController.create({
            message,
            duration: duration ?? this.defaultDuration,
            position: 'bottom',
            color: this.getColor(type),
            icon: this.getIcon(type),
            buttons: [
                {
                    icon: 'close',
                    role: 'cancel'
                }
            ]
        });

        await toast.present();
    }

    // Métodos rápidos (DX melhor)
    success(message: string, duration?: number) {
        return this.show(message, 'success', duration);
    }

    error(message: string, duration?: number) {
        return this.show(message, 'error', duration);
    }

    warning(message: string, duration?: number) {
        return this.show(message, 'warning', duration);
    }

    info(message: string, duration?: number) {
        return this.show(message, 'info', duration);
    }

    // Helpers privados
    private getColor(type: ToastType): string {
        switch (type) {
            case 'success': return 'success';
            case 'error': return 'danger';
            case 'warning': return 'warning';
            default: return 'primary';
        }
    }

    private getIcon(type: ToastType): string {
        switch (type) {
            case 'success': return 'checkmark-circle-outline';
            case 'error': return 'close-circle-outline';
            case 'warning': return 'alert-circle-outline';
            default: return 'information-circle-outline';
        }
    }
}